import { localize } from "utils/localizer";

const i18n = {
    acceptContracts: {
        en: "I have read and understood the contract and agreements.",
        de: "Ich habe die Vertragsbedingungen gelesen und akzeptiert.",
    },
    account: {
        en: "Account",
        de: "Konto",
    },
    activeCheckIn: {
        en: (clubName: string, until: string) => `You are checked-in at ${clubName} until ${until}.`,
        de: (clubName: string, until: string) => `Du bist bei ${clubName} bis ${until} eingecheckt.`,
    },
    activities: {
        en: "Activities",
        de: "Aktivitäten",
    },
    admin: {
        en: "Admin",
        de: "Admin",
    },
    allRight: {
        en: "All right",
        de: "Alles klar",
    },
    anErrorOccurred: {
        en: "An error occurred",
        de: "Ein Fehler ist aufgetreten",
    },
    autoSignOut: {
        en: (seconds: number) => `You will be automatically signed out after ${seconds}s.`,
        de: (seconds: number) => `Du wirst in ${seconds}s automatisch abgemeldet.`,
    },
    bookings: {
        en: "Bookings",
        de: "Buchungen",
    },
    calendar: {
        en: "Calendar",
        de: "Kalender",
    },
    cancel: {
        en: "Cancel",
        de: "Abbrechen",
    },
    checkIn: {
        en: "Check-in",
        de: "Einchecken",
    },
    checkOut: {
        en: "Check-out",
        de: "Auschecken",
    },
    club: {
        en: "Location",
        de: "Sportstätte",
    },
    settingForCompany: {
        en: "Settings",
        de: "Einstellungen",
    },
    completeContactData: {
        en: "Please complete your contact data and try again.",
        de: "Bitte vervollständige deine Kontaktdaten und versuche es erneut.",
    },
    contractsRequired: {
        en: "The following contracts apply when using PLAYSPORTS:",
        de: "Folgende Verträge liegen der Nutzung von PLAYSPORTS zugrunde:",
    },
    courts: {
        en: "Courts",
        de: "Plätze",
    },
    dashboard: {
        en: "Dashboard",
        de: "Dashboard",
    },
    daysRemaining: {
        en: (days: number) => `${days} ${(days === 1) ? "day" : "days"} remaining`,
        de: (days: number) => `${days} ${(days === 1) ? "Tag" : "Tage"} verbleibend`,
    },
    demo: {
        en: "Demo",
        de: "Demo",
    },
    documents: {
        en: "Documents",
        de: "Dokumente",
    },
    duration: {
        en: "Duration",
        de: "Dauer",
    },
    endDemo: {
        en: "End demo",
        de: "Demo beenden",
    },
    endDemoCosts: {
        en: "There are no additional costs incurred",
        de: "Hierdurch entstehen keine Kosten",
    },
    endDemoDesc: {
        en: "When you migrate to a full PLAYSPORTS location, you will have access to all functionality. All previously entered data remain unchanged.",
        de: "Durch die Migration zu einem vollwertigen PLAYSPORTS-Unternehmen entfallen die Restriktionen des Demo-Modus. Alle bisher eingegebenen Daten bleiben erhalten.",
    },
    endDemoDisabled: {
        en: "After we checked your data, you can end the demo mode of your club in order to have access to all functionality. If this takes longer than 48 hours, please contact our support.",
        de: "Sobald wir deine Daten geprüft haben, kann dein Unternehmen die Demo-Phase beenden und PLAYSPORTS in vollem Umfang nutzen. Sollte dies länger als 48 Stunden dauern, wende dich bitte an unseren Support.",
    },
    endDemoSuccess: {
        en: "Ended demo mode successfully. Your location is now live!",
        de: "Demo-Modus erfolgreich beendet. Dein Unternehmen ist jetzt live!",
    },
    extendDemo: {
        en: "Extend Demo",
        de: "Demo Verlängern",
    },
    extendDemoSuccess: {
        en: "Extended demo mode successfully.",
        de: "Demo-Modus erfolgreich verlängert.",
    },
    feedbackConsent: {
        en: "I give permission to contact me for clarifying questions (optional)",
        de: "Ich erlaube die Kontaktaufnahme bzgl. Rückfragen (optional)",
    },
    feedbackDesc: {
        en: "If you encountered problems or miss a function while using the new dashboard, please tell us about it.",
        de: "Wenn beim Verwenden des neuen Dashboards Probleme aufgetreten sind oder dir eine wichtige Funktion fehlt, teile uns dies gerne mit.",
    },
    feedbackPlaceholder: {
        en: "Detailed feedback (suggestions, changes, etc.)",
        de: "Ausführliches Feedback (Verbesserungsvorschläge, Änderungen, etc.)",
    },
    hello: {
        en: (name: string) => `Hello ${name}!`,
        de: (name: string) => `Hallo ${name}!`,
    },
    help: {
        en: "Help",
        de: "Hilfe",
    },
    hideMenu: {
        en: "Hide Menu",
        de: "Menü verstecken",
    },
    home: {
        en: "Home",
        de: "Übersicht",
    },
    hours: {
        en: (hours: number) => `${hours} Hour${hours === 1 ? "" : "s"}`,
        de: (hours: number) => `${hours} Stunde${hours === 1 ? "" : "n"}`,
    },
    language: {
        en: "Language",
        de: "Sprache",
    },
    languages: {
        en: {
            de: "Deutsch",
            en: "English",
        },
    },
    logoutDashboard: {
        en: "Logout Dashboard",
        de: "Dashboard abmelden",
    },
    members: {
        en: "Members",
        de: "Mitglieder",
    },
    menu: {
        en: "Menu",
        de: "Menü",
    },
    migrateNow: {
        en: "Go live now",
        de: "Jetzt live gehen",
    },
    migrateNowOwnerOnly: {
        en: "Can only be done by the location owner.",
        de: "Kann nur vom Eigentümer der Sportstätte vorgenommen werden.",
    },
    myProfile: {
        en: "My Profile",
        de: "Mein Profil",
    },
    notifications: {
        en: "Notifications",
        de: "Benachrichtigungen",
    },
    ok: {
        en: "Ok",
        de: "Ok",
    },
    onboarding: {
        en: "Onboarding",
        de: "Erste Schritte",
    },
    onboardingSteps: {
        en: {
            owner: {
                0: "Check data",
                1: "Add members",
                2: "Create courts",
                3: "Create booking",
                4: "Go live now",
                5: "Connect to Stripe",
                6: "Switch to public",
            },
            admin: {
                0: "Add members",
                1: "Create courts",
                2: "Create booking",
            },
        },
        de: {
            owner: {
                0: "Daten überprüfen",
                1: "Mitglieder hinzufügen",
                2: "Plätze anlegen",
                3: "Buchung erstellen",
                4: "Jetzt live gehen",
                5: "Mit Stripe verbinden",
                6: "Öffentlich schalten",
            },
            admin: {
                0: "Mitglieder hinzufügen",
                1: "Plätze anlegen",
                2: "Buchung erstellen",
            },
        },
    },
    companyOnboardingSteps: {
        en: {
            owner: {
                0: "Check data",
                1: "ADD EMPLOYEES",
                2: "Plan events",
                3: "Go live now",
            },
            admin: {
                0: "Add members",
                1: "Create courts",
                2: "Create booking",
            },
        },
        de: {
            owner: {
                0: "Daten überprüfen",
                1: "MITARBEITER*INNEN HINZUFÜGEN",
                2: "Events planen",
                3: "Jetzt live gehen",
            },
            admin: {
                0: "Mitglieder hinzufügen",
                1: "Plätze anlegen",
                2: "Buchung erstellen",
            },
        },
    },
    onboardingStepsDesc: {
        en: {
            owner: {
                0: "Check whether all the data on your sports location are correct, in particular the address and the latitude and longitude. Then click on \"Save\". You can make further settings under the tabs Bookings, Members, etc.",
                1: "Here you manage the members of your sports location. Under the tab \"Import\" you can simply invite new members. During the demo period, the number is limited to 4 additional users, thereafter unlimited.",
                2: "Here you manage the courts of your sports location. New courts can be created at any time using the plus button at the top right.",
                3: "As soon as you have created a court, you can click on your desired time in the calendar and create your first booking. Click on the created booking in the calendar to display further actions.",
                5: "Connect your sports location with Stripe to enable paid bookings (e.g. for guests). However, you must first enter your tax number.",
                6: "Change the visibility of your sports location to public in order to enable all PLAYSPORTS users to book your courts and your events.",
            },
            admin: {
                0: "Here you manage the members of your sports location. Under the tab \"Import\" you can simply invite new members. During the test period the number is limited to 4 additional users, thereafter unlimited.",
                1: "Here you manage the courts of your sports location. New courts can be created at any time using the plus button at the top right.",
                2: "As soon as you have created a court, you can create a booking via \"New booking\". Click on the created booking in the calendar to display further actions.",
            },
        },
        de: {
            owner: {
                0: "Überprüfe, ob alle Daten zu deiner Sportstätte korrekt sind, insbesondere die Adresse und den Breiten- und Längengrad. Klicke anschließend auf \"Speichern\". Unter den Reitern Buchungen, Mitglieder, etc. kannst du weitere Einstellungen vornehmen.",
                1: "Hier verwaltest du die Mitglieder deiner Sportstätte. Unter dem Reiter \"Importieren\" kannst du einfach neue Mitglieder einladen. Während des Testzeitraums ist die Anzahl auf 4 weitere Nutzer beschränkt, danach unbegrenzt.",
                2: "Hier verwaltest du die Plätze deiner Sportstätte. Neue Plätze können jederzeit über den Plus-Knopf oben rechts angelegt werden.",
                3: "Sobald du einen Platz angelegt hast, kannst du im Kalender auf deine Wunschzeit klicken und deine erste Buchung erstellen. Klicke auf die erstellte Buchung im Kalender, um weitere Aktionen einzublenden.",
                5: "Verbinde deine Sportstätte mit Stripe, um bezahlte Buchungen (z.B. für Gäste) zu ermöglichen. Zuvor ist jedoch die Eingabe der Steuernummer notwendig.",
                6: "Ändere die Sichtbarkeit deine Sportstätte auf öffentlich, um allen PLAYSPORTS Nutzern Buchungen deiner Plätze und deiner Events zu ermöglichen.",
            },
            admin: {
                0: "Hier verwaltest du die Mitglieder deiner Sportstätte. Unter dem Reiter \"Importieren\" kannst du einfach neue Mitglieder einladen. Während des Testzeitraums ist die Anzahl auf 4 weitere Nutzer beschränkt, danach unbegrenzt.",
                1: "Hier verwaltest du die Plätze deiner Sportstätte. Neue Plätze können jederzeit über den Plus-Knopf oben rechts angelegt werden.",
                2: "Sobald du Plätze angelegt hast, kannst du über \"Neu Buchen\" eine Buchung erstellen. Klicke auf die erstellte Buchung im Kalender, um weitere Aktionen einzublenden.",
            },
        },
    },
    companyOnboardingStepsDesc: {
        en: {
            owner: {
                0: "This is where you set up your company profile. In the other tabs you can select your subscription, save a payment method and billing address and call up monthly reports.",
                1: "Here you manage the employees of your company. You can simply invite new employees under the \"Import\" tab.",
                2: "Here you can plan new events and see upcoming events.",
            },
            admin: {
                0: "Here you manage the members of your sports location. Under the tab \"Import\" you can simply invite new members. During the test period the number is limited to 4 additional users, thereafter unlimited.",
                1: "Here you manage the courts of your sports location. New courts can be created at any time using the plus button at the top right.",
                2: "As soon as you have created a court, you can create a booking via \"New booking\". Click on the created booking in the calendar to display further actions.",
            },
        },
        de: {
            owner: {
                0: "Hier richtest du dein Unternehmensprofil ein. In den anderen Tabs kannst du dein Abo auswählen, eine Zahlungsmethode und Rechnungsadresse hinterlegen und Monats-Reports abrufen.",
                1: "Hier verwaltest du die Mitarbeiter*innen deines Unternehmens. Unter dem Reiter \"Importieren\" kannst du einfach neue Mitarbeiter*innen einladen.",
                2: "Hier kannst du neue Events Planen und siehst bevorstehende Veranstaltungen.",
            },
            admin: {
                0: "Hier verwaltest du die Mitglieder deiner Sportstätte. Unter dem Reiter \"Importieren\" kannst du einfach neue Mitglieder einladen. Während des Testzeitraums ist die Anzahl auf 4 weitere Nutzer beschränkt, danach unbegrenzt.",
                1: "Hier verwaltest du die Plätze deiner Sportstätte. Neue Plätze können jederzeit über den Plus-Knopf oben rechts angelegt werden.",
                2: "Sobald du Plätze angelegt hast, kannst du über \"Neu Buchen\" eine Buchung erstellen. Klicke auf die erstellte Buchung im Kalender, um weitere Aktionen einzublenden.",
            },
        },
    },
    reload: {
        en: "Reload",
        de: "Neu laden",
    },
    showContract: {
        en: "Show contract",
        de: "Vertrag zeigen",
    },
    signOut: {
        en: "Sign Out",
        de: "Abmelden",
    },
    signOutNow: {
        en: "Sign out now",
        de: "Sofort abmelden",
    },
    somethingWentWrong: {
        en: "Something went wrong. Please try reloading the app.",
        de: "Etwas ist schiefgelaufen. Bitte versuche die App neu zu laden.",
    },
    status: {
        en: "Status",
        de: "Status",
    },
    staySignedIn: {
        en: "Stay signed in",
        de: "Angemeldet bleiben",
    },
    submit: {
        en: "Submit",
        de: "Abschicken",
    },
    submitFeedback: {
        en: "Submit Feedback",
        de: "Feedback geben",
    },
    trainer: {
        en: "Coach",
        de: "Trainer",
    },
    updatedContracts: {
        en: "Updated Contracts",
        de: "Aktualisierte Verträge",
    },
    userProfile: {
        en: "User Profile",
        de: "Benutzerprofil",
    },
    userRoles: {
        en: {
            standard: "Standard",
            trainer: "Coach",
            groundskeeper: "Groundskeeper",
            admin: "Admin",
            owner: "Owner",
        },
        de: {
            standard: "Standard",
            trainer: "Trainer",
            groundskeeper: "Platzwart",
            admin: "Admin",
            owner: "Eigentümer",
        },
    },
    youAreOffline: {
        en: "You're offline. Please check your network connection.",
        de: "Du bist offline. Bitte überprüfe deine Internetverbindung.",
    },
    welcome: {
        en: "Welcome",
        de: "Willkommen",
    },
    B2BFeatures: {
        en: "B2B-Features",
        de: "B2B-Funktionen",
    },
    challenge: {
        en: "Challenges",
        de: "Challenges",
    },
};

export default localize(i18n);
